module.exports = __webpack_public_path__ + "static/media/latch.9a23f3e2.png";